import HomeView from 'features/home/view/HomeView';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { useAuthInfo } from './features/auth/hooks/useAuthInfo';
import LoginView from './features/auth/view/LoginView';
import systemSlice from './redux/slice/system.slice';

function App(): JSX.Element {
  const system = useAuthInfo();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const fromStorageToState = () => {
      const userDetails = localStorage.getItem('user_details');
      if (userDetails) {
        const userDetailsJson = JSON.parse(userDetails);
        dispatch(systemSlice.actions.setState(userDetailsJson));
      }
    };

    fromStorageToState();
  }, [dispatch]);

  return (
    <div>
      {!system.isLogged && (
        <Switch>
          <Route path="/" component={LoginView} />
        </Switch>
      )}
      {system.isLogged && <HomeView />}
    </div>
  );
}

export default App;
